<div class="flex h-full w-full items-center justify-center bg-proffeo-surface-page">
  <div class="flex flex-col items-center justify-center gap-5">
    <div class="flex items-center gap-4">
      <div class="flex items-center gap-2">
        <img
          src="/img/logo/logo.png"
          alt="logo"
          class="w-11"
        />
        <p class="proffeo-ui-text-display">Proffeo</p>
      </div>
      <proffeo-lang-toggle></proffeo-lang-toggle>
    </div>
    <div class="min-w-90 flex items-center justify-center border-default bg-proffeo-surface p-8">
      <div class="flex w-full flex-col gap-2">
        <div class="flex w-full items-center justify-center">
          <p class="proffeo-ui-text-display text-center">
            {{ 'confirm-email-set-password-activate-account' | translate }}
          </p>
        </div>
        <form
          [formRoot]="form"
          class="flex flex-col gap-4 pt-5"
        >
          @if (!showIncorrectLinkAlert() && !invalidLink()) {
            <proffeo-ui-input
              [formField]="form.newPassword"
              label="confirm-email-set-password-new-password"
              type="password"
              autocomplete="new-password"
            />

            <proffeo-ui-input
              [formField]="form.newPasswordConfirm"
              label="confirm-email-set-password-new-password-confirm"
              type="password"
              autocomplete="new-password"
            />
          }

          <div class="flex flex-col items-center justify-center gap-2">
            @if (!result().success && !showIncorrectLinkAlert() && !invalidLink()) {
              <div class="flex w-full items-center justify-center pt-3">
                <proffeo-ui-button
                  (clicked)="onSubmitForm()"
                  [disabled]="requestSent()"
                  variant="accent"
                  text="confirm-email-set-password-set-password"
                ></proffeo-ui-button>
              </div>
            }

            @if (result().success) {
              <p class="text-base text-proffeo-success">
                {{ 'confirm-email-set-password-success' | translate }}
              </p>
              <p class="text-base font-light">
                {{ 'confirm-email-set-password-your-password-has-been-set' | translate }}
              </p>
            }

            @if (showIncorrectLinkAlert() || result().error || invalidLink()) {
              <p class="text-base text-proffeo-danger">
                {{ 'reset-password-the-link-you-followed-has-expired' | translate }}
              </p>
              <p class="flex cursor-pointer items-center gap-1 text-base font-light">
                {{ 'confirm-email-set-password-please-contact-with-administrator' | translate }}
              </p>
            }
          </div>

          <div class="flex w-full flex-col items-center justify-center">
            <p
              routerLink="/sign-in"
              class="cursor-pointer text-sm hover:opacity-75"
            >
              Go back to Login...
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
